import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { profileAPI } from "../services/api";
import Button from "../components/Button";
import "../components/Form.css";

const VerifyEmailChange = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");
  const hasVerifiedRef = useRef(false);
  const redirectTimeoutRef = useRef(null);

  const verifyEmailChange = React.useCallback(async (token) => {
    if (hasVerifiedRef.current) {
      return;
    }

    hasVerifiedRef.current = true;

    try {
      const response = await profileAPI.verifyEmailChange(token);

      setStatus("success");
      setMessage("Email Changed Successfully");
      updateUser({ email: response.data.user.email });

      redirectTimeoutRef.current = window.setTimeout(() => {
        navigate("/profile");
      }, 8000);
    } catch (error) {
      setStatus("error");
      setMessage(
        error.response?.data?.details?.[0] || "Failed to verify email change",
      );

      redirectTimeoutRef.current = window.setTimeout(() => {
        navigate("/profile");
      }, 8000);
    }
  }, [navigate, updateUser]);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Invalid verification link");
      return;
    }

    verifyEmailChange(token);

    return () => {
      if (redirectTimeoutRef.current) {
        window.clearTimeout(redirectTimeoutRef.current);
      }
    };
  }, [searchParams, verifyEmailChange]);

  const handleGoToProfile = () => {
    navigate("/profile");
  };

  return (
    <div className="form-container">
      <div className="form-form">
        {status === "verifying" && (
          <>
            <h2>Verifying Email Change...</h2>
            <p>Please wait while we verify your new email address.</p>
          </>
        )}

        {status === "success" && (
          <>
            <h2>Email Changed Successfully</h2>
            <p className="form-redirect-note">
              Redirecting to profile in 8 seconds...
            </p>
            <div className="form-redirect-action">
              <Button
                onClick={handleGoToProfile}
                className="button-btn button-btn-blue"
              >
                Go to Profile Now
              </Button>
            </div>
          </>
        )}

        {status === "error" && (
          <>
            <h2>Email Change Failed</h2>
            <p>{message}</p>
            <p className="form-redirect-note">
              Redirecting to profile in 8 seconds...
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailChange;
